import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react'

export default function DatePicker(props) {
    const { name, label, value, onChange, error=null , ...rest } = props;
    const handleOnChange = (name, value) => ({target: { name, value }})

    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MUIDatePicker
                label={label}
                value={value}
                onChange={newVal => onChange(handleOnChange(name, newVal))}
                inputFormat="MM/dd/yyyy"
                name={name}
                {...rest}
                renderInput={(params) => <TextField fullWidth {...params} {...(error && { error: true, helperText: error })} />}
            />
        </LocalizationProvider>
    )
}
